import React, { useState } from "react";
import "./Contact_Us.css";
import { Form } from "react-bootstrap";
import Common_Btn from "../../common/common-btn/Common_Btn";
import { useForm } from "react-hook-form";
import { ContactUsForm } from "../../../utils/gymOwnerApi";
import Full_Screen_Modal from "../../full-screen-modal/Full_Screen_Modal";
import { Registration_Lottie } from "../../lotties/registration-lottie/Registration_Lottie";

const Contact_Us = () => {
  const [submitting, setSubmitting] = useState(false);
  const [showModal, setShowModal] = useState(false); // ← added
  const [apiError, setApiError] = useState("");

  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm();

  const onSubmit = async (data) => {
    setSubmitting(true);
    setApiError("");

    const form = new FormData();
    form.append("name", data.name);
    form.append("email", data.email);
    form.append("mobile_number", data.mobile_number);
    form.append("message", data.message);

    try {
      const response = await ContactUsForm(data);

      if (response.status) {
        reset();
        setShowModal(true);
        setTimeout(() => {
          setShowModal(false);
        }, 2500);
      }
    } catch (err) {
      const errMsg =
        err?.response?.data?.message ||
        err?.response?.data?.detail ||
        "Something went wrong. Please try again.";
      setApiError(errMsg);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <section id="contact_us" className="contact_section">
      <div className="contact_title_holder">
        <h2 className="contact_title">
          Let's Start a <br /> <span>Conversation!</span>
        </h2>
      </div>

      <div className="contact_banner_holder">
        <div className="row justify-content-center">
          <div className="col-lg-5 col-12 order-lg-1 order-2">
            <div className="solo_img_holder">
              <img
                src="/Assets/images/contact-us/solo-img.png"
                className="solo_img"
                alt="contact"
              />
            </div>
          </div>

          <div className="col-lg-5 col-md-9 col-12 order-lg-2 order-1">
            <div className="contact_form_holder">
              <h2 className="contact">Contact Us</h2>
              <Form onSubmit={handleSubmit(onSubmit)}>

                {/* Name */}
                <Form.Group className="mb-3">
                  <Form.Control
                    type="text"
                    placeholder="Enter your name"
                    className="contact_input"
                    isInvalid={!!errors.name}
                    {...register("name", {
                      required: "Name is required",
                      minLength: { value: 2, message: "Minimum 2 characters" },
                    })}
                  />
                  <Form.Control.Feedback type="invalid">
                    {errors.name?.message}
                  </Form.Control.Feedback>
                </Form.Group>

                <div className="row">
                  {/* Email */}
                  <div className="col-lg-6 col-md-6 col-sm-6">
                    <Form.Group className="mb-3">
                      <Form.Control
                        type="text"
                        placeholder="Enter your email"
                        className="contact_input"
                        isInvalid={!!errors.email}
                        {...register("email", {
                          required: "Email is required",
                          pattern: {
                            value: /^[a-zA-Z0-9]+([._%+-]?[a-zA-Z0-9]+)*@[a-zA-Z0-9-]+(\.[a-zA-Z]{2,})+$/,
                            message: "Enter a valid email address",
                          },
                        })}
                      />
                      <Form.Control.Feedback type="invalid">
                        {errors.email?.message}
                      </Form.Control.Feedback>
                    </Form.Group>
                  </div>

                  {/* Mobile Number */}
                  <div className="col-lg-6 col-md-6 col-sm-6">
                    <Form.Group className="mb-3">
                      <Form.Control
                        type="text"
                        placeholder="Enter your number"
                        className="contact_input"
                        isInvalid={!!errors.mobile_number}
                        {...register("mobile_number", {
                          required: "Mobile number is required",
                          pattern: {
                            value: /^[0-9]+$/,
                            message: "Only digits are allowed",
                          },
                          minLength: {
                            value: 10,
                            message: "Mobile number must be exactly 10 digits",
                          },
                          maxLength: {
                            value: 10,
                            message: "Mobile number must be exactly 10 digits",
                          },
                        })}
                      />
                      <Form.Control.Feedback type="invalid">
                        {errors.mobile_number?.message}
                      </Form.Control.Feedback>
                    </Form.Group>
                  </div>
                </div>

                {/* Message */}
                <Form.Group className="mb-4">
                  <Form.Control
                    as="textarea"
                    rows={3}
                    placeholder="Type here..."
                    className="contact_textarea"
                    isInvalid={!!errors.message}
                    {...register("message", {
                      required: "Message is required",
                      minLength: { value: 10, message: "Minimum 10 characters" },
                    })}
                  />
                  <Form.Control.Feedback type="invalid">
                    {errors.message?.message}
                  </Form.Control.Feedback>
                </Form.Group>

                {/* API Error */}
                {apiError && (
                  <div className="alert alert-danger py-2">{apiError}</div>
                )}

                <div className="submit_btn_holder">
                  <Common_Btn
                    btnText={submitting ? "Sending..." : "Submit"}
                    type="submit"
                    disabled={submitting}
                  />
                </div>

              </Form>
            </div>
          </div>
        </div>
      </div>

      {/* Success Modal */}
      <Full_Screen_Modal
        show={showModal}
        onHide={() => setShowModal(false)}
        lottie={<Registration_Lottie />}
      />
    </section>
  );
};

export default Contact_Us;